<ion-app>
  <div class="impersonation-banner" *ngIf="authService.isImpersonating">
    Modo de Impersonación Activo
  </div>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
